import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export interface NudgesSettingsState {
    isAllowed: boolean;
}

const createInitialState = (): NudgesSettingsState => ({
    isAllowed: false,
});

@singleton()
@StoreConfig({ name: "NudgesSettingsStore" })
class NudgesSettingsStore extends BaseStore<NudgesSettingsState> {
    constructor() {
        super(createInitialState());
    }
}

export default NudgesSettingsStore;
